import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import { selectBuyerWelcomeVideoId, selectBuyerWelcomeVideoType, selectBuyerWelcomeVideoUrl } from '../../../../store/selectors/videos'
import { selectCustomerFirstName } from '../../../../store/selectors/customerProfile'
import { Player } from '../../../shared/Player'
import {
  Box,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@homebotapp/hb-react-component-catalog'

export interface BuyerWelcomeVideoModalProps {
  handleSubmitClick: () => void
}

const BuyerWelcomeVideoModal = ({ handleSubmitClick }: BuyerWelcomeVideoModalProps) => {
  const videoId = useSelector(selectBuyerWelcomeVideoId)
  const videoType = useSelector(selectBuyerWelcomeVideoType)
  const videoUrl = useSelector(selectBuyerWelcomeVideoUrl)
  const customerFirstName = useSelector(selectCustomerFirstName)

  return (
    <Modal onClose={handleSubmitClick} onOverlayClick={handleSubmitClick} isOpen={true}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading textAlign='left' size='sm'>
            <FormattedMessage id='BuyerWelcomeVideo.title' defaultMessage='👋 Welcome to your For You page' />
          </Heading>
        </ModalHeader>
        <ModalBody paddingBottom={10}>
          <Box>
            <Text fontWeight={600} color='neutral-900'>
              <FormattedMessage
                id='BuyerWelcomeVideo.subTitle1'
                defaultMessage='This is your home for all things homebuying.'
              />
            </Text>
            <Text color='neutral-700'>
              <FormattedMessage
                id='BuyerWelcomeVideo.subTitle2'
                defaultMessage='Here’s a short video from {customerFirstName} to get you started.'
                values={{
                  customerFirstName: customerFirstName as string
                }}
              />
            </Text>
            <Box>
              <Player videoType={videoType} videoId={videoId} videoUrl={videoUrl} />
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button as={Flex} alignSelf='flex-end' size='lg' w='100%' colorScheme='primary' onClick={handleSubmitClick}>
            <FormattedMessage id='BuyerWelcomeVideo.button' defaultMessage="Let's go!" />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default BuyerWelcomeVideoModal
